import { useQuery } from "react-query";
import { fetchDPCOverview } from "../services/dpc/dpc.api";

export function useDpcs(partnerId?: string, settings?: any) {
  const { data: dpcs, ...rest } = useQuery(
    ["dpcs", partnerId],
    () => fetchDPCOverview(partnerId),
    {
      enabled: !!partnerId,
      ...settings,
    }
  );

  return {
    dpcs,
    ...rest,
  };
}
